import React from "react";

function EmbeddedTypeStep({ handleChange, formData }) {
  return (
    <>
      <div className="row pb-5 pb-sm-5 pb-md-5 pb-lg-5 pb-xl-5">
        <div className="col-lg-12">
          <div className="pt-3 mt-3">
            <h2 className="h6 pb-1 mb-3 color_grey">
              Great! Let’s Narrow This Step Down.
            </h2>
            {/* Required Field: Must choose one. */}
            <div className="nav nav-pills row row-cols-2 row-cols-sm-3 row-cols-md-3 gap-0 g-3">
              {/* Vending Machine */}
              <div className="col">
                <input
                  type="radio"
                  className="btn-check"
                  id="vending-machine"
                  name="embedded-category"
                  value="Vending Machine"
                  onChange={handleChange}
                  checked={formData["embedded-category"] === "Vending Machine"}
                />
                <label
                  className="nav-link flex-column w-100 align-items-center gap-2 rounded p-3"
                  htmlFor="vending-machine"
                >
                  <img
                    className="main__icon"
                    src="/assets/icons/otomat_machine.svg"
                    alt="Vending Machine"
                  />
                  <div className="main_card_info">
                    <h3>Vending Machine</h3>
                    <p>
                      Smart and advanced custom software solutions for vending
                      machines that are Industry 4.0 compliant and based on IoT.
                    </p>
                  </div>
                </label>
              </div>

              {/* Robotic Device */}
              <div className="col">
                <input
                  type="radio"
                  className="btn-check"
                  id="robotic"
                  name="embedded-category"
                  value="Robotic Device"
                  onChange={handleChange}
                  checked={formData["embedded-category"] === "Robotic Device"}
                />
                <label
                  className="nav-link flex-column w-100 align-items-center gap-2 rounded p-3"
                  htmlFor="robotic"
                >
                  <img
                    className="main__icon"
                    src="/assets/icons/robotic.svg"
                    alt="Robotic Device"
                  />
                  <div className="main_card_info">
                    <h3>Robotic Device</h3>
                    <p>
                      Robotic Software Development, Real-Time Control and
                      Hardware-in-the-Loop Simulation, Sensing Systems, Control
                      Software, etc.
                    </p>
                  </div>
                </label>
              </div>

              {/* Human-Machine Interfaces (HMI) */}
              <div className="col">
                <input
                  type="radio"
                  className="btn-check"
                  id="hmi"
                  name="embedded-category"
                  value="Human-Machine Interfaces (HMI)"
                  onChange={handleChange}
                  checked={
                    formData["embedded-category"] ===
                    "Human-Machine Interfaces (HMI)"
                  }
                />
                <label
                  className="nav-link flex-column w-100 align-items-center gap-2 rounded p-3"
                  htmlFor="hmi"
                >
                  <img
                    className="main__icon"
                    src="/assets/icons/hmi.svg"
                    alt="HMI"
                  />
                  <div className="main_card_info">
                    <h3>Human-Machine Interfaces (HMI)</h3>
                    <p>
                      Integration of Hardware and Embedded Resources with UX/UI,
                      Data Visualization Applications, Complex Web, and
                      Cloud-Based HMI Systems.
                    </p>
                  </div>
                </label>
              </div>

              {/* Sensor Application */}
              <div className="col">
                <input
                  type="radio"
                  className="btn-check"
                  id="sensor-app"
                  name="embedded-category"
                  value="Sensor Application"
                  onChange={handleChange}
                  checked={
                    formData["embedded-category"] === "Sensor Application"
                  }
                />
                <label
                  className="nav-link flex-column w-100 align-items-center gap-2 rounded p-3"
                  htmlFor="sensor-app"
                >
                  <img
                    className="main__icon"
                    src="/assets/icons/sensor.svg"
                    alt="Sensor Application"
                  />
                  <div className="main_card_info">
                    <h3>Sensor Application</h3>
                    <p>
                      Custom Sensor Applications, Data Capture, Processing, and
                      Visualization from Sensor Systems, Sensor Interface
                      Development.
                    </p>
                  </div>
                </label>
              </div>

              {/* Security System */}
              <div className="col">
                <input
                  type="radio"
                  className="btn-check"
                  id="security-embedded"
                  name="embedded-category"
                  value="Security System"
                  onChange={handleChange}
                  checked={formData["embedded-category"] === "Security System"}
                />
                <label
                  className="nav-link flex-column w-100 align-items-center gap-2 rounded p-3"
                  htmlFor="security-embedded"
                >
                  <img
                    className="main__icon"
                    src="/assets/icons/connect.svg"
                    alt="Security System"
                  />
                  <div className="main_card_info">
                    <h3>Security System</h3>
                    <p>
                      On-Device Storage, Communication Between Hardware and
                      Protocols, Cloud Gateways, Device Management Systems,
                      Authentication.
                    </p>
                  </div>
                </label>
              </div>

              {/* Embedded Software */}
              <div className="col">
                <input
                  type="radio"
                  className="btn-check"
                  id="embedded-software"
                  name="embedded-category"
                  value="Embedded Software"
                  onChange={handleChange}
                  checked={
                    formData["embedded-category"] === "Embedded Software"
                  }
                />
                <label
                  className="nav-link flex-column w-100 align-items-center gap-2 rounded p-3"
                  htmlFor="embedded-software"
                >
                  <img
                    className="main__icon"
                    src="/assets/icons/board.svg"
                    alt="Embedded Software"
                  />
                  <div className="main_card_info">
                    <h3>Embedded Software</h3>
                    <p>
                      System Development, Embedded Integrations, Digital Signal
                      Processing, AI-Based Software, Remote Control via Wi-Fi,
                      Bluetooth, GPRS.
                    </p>
                  </div>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EmbeddedTypeStep;
